import type { IconProps } from './types';

export function Calcinha({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M56 88 Q128 84 200 88 Q200 100 200 112 Q198 116 192 120 Q176 196 136 204 Q128 208 120 204 Q80 196 64 120 Q58 116 56 112 Q56 100 56 88 Z" />
      <path d="M56 112 Q128 116 200 112" />
    </svg>
  );
}
